import React, { useState, useCallback, useEffect } from "react";
import { observer } from "mobx-react-lite";

import "./MainMenu.scss";
import Svg from "../svg/Svg";
import { Toggle as ToggleIcon, mainMenuItems } from "../svg/svgImageList";
import MainMenuItem from "./MainMenuItem";
import useThemeService from "../../services/theme-service/ThemeService";
import useMainMenuService from "../../services/main-menu/MainMenuService";
import useMainMenuStorage from "../../services/main-menu/MainMenuStorageService";

interface MainMenuType {
  onMenuToggle?: Function;
}

export default observer(function MainMenu(props: MainMenuType) {
  const { onMenuToggle } = { ...props };
  const { themeClass } = useThemeService();
  const { menuCategories } = useMainMenuService();
  const { setMainMenuOpenState, getMainMenuOpenState } = useMainMenuStorage();
  const [openMainMenu, setOpenMainMenu] = useState(() => {
    return getMainMenuOpenState();
  });

  const handleOpenMenu = useCallback(() => {
    setOpenMainMenu((openMainMenu) => !openMainMenu);
  }, []);

  useEffect(() => {
    setMainMenuOpenState(openMainMenu);
  }, [openMainMenu, setMainMenuOpenState]);

  useEffect(() => {
    if (onMenuToggle) {
      onMenuToggle(openMainMenu);
    }
  }, [openMainMenu, onMenuToggle]);

  return (
    <aside>
      <nav className={themeClass(["nav-main-menu"])}>
        <header className="main-menu-header">
          <Svg
            svg={ToggleIcon}
            className={themeClass(["main-menu-toggle"], [!openMainMenu ? "reverse-toggle" : ""])}
            onClick={() => handleOpenMenu()}
          />
        </header>
        <div>
          {menuCategories.map(
            (menuCategory) =>
              menuCategory.canAccess && (
                <MainMenuItem
                  key={menuCategory.name}
                  svg={mainMenuItems[menuCategory.name]}
                  item={menuCategory}
                  wideMenu={openMainMenu}
                />
              )
          )}
        </div>
      </nav>
    </aside>
  );
});
